@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/design-tokens/typography/typography' as *;

.card {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.cardHeader {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}

.cardEyebrow,
.cardMetaText,
.cardPrompt,
.cardTitle {
  margin: 0;
}

.cardEyebrow {
  @include typography-v2-ui-xs;
}

.cardMeta {
  display: flex;
  align-items: center;
  gap: 12px;
}

.cardMetaText {
  @include typography-v2-ui-xs;
  color: var(--text-soft);
}

.cardTitle {
  @include typography-v2-title-base;
}

.cardPrompt {
  @include typography-v2-body-sm;
}

.cardAction {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;
}

.editInput {
  @include typography-v2-body-sm;
  @include border-radius-r2;
  width: 100%;
  padding: 8px 12px;
  resize: none;
  background: var(--surface-default);
  border: 1px solid var(--border-soft);
  color: var(--text-default);

  &:focus,
  &:focus-visible {
    border-color: var(--border-primary);
    outline: none;
  }
}
